<button
  type="button"
  class="w-full flex flex-row justify-center items-center gap-2 rounded-[6px] py-2 px-4 box-border"
  [ngClass]="{
    'btn-add-item': buttonStyle === 'add-item',
    'btn-action': buttonStyle === 'action',
    'disabled:text-[#A9BCD9] disabled:!bg-[#edf4fb] disabled:!cursor-not-allowed disabled:!border-[#edf4fb]':
      disabled,
  }"
  [disabled]="disabled"
  (click)="onClick($event)"
>
  <ui-icon [attr.name]="icon" [fill]="iconFill" m-size="20" size="20" />
  <ui-paragraph
    type="p12"
    mobile-type="p12"
    font-weight="semibold"
    text-color="neutrals-900"
  >
    {{ text }}
  </ui-paragraph>
</button>
